import clsx from 'clsx'
import { CONSTS } from 'config/objectConst'
import { campaignHooks } from 'features/campaigns'
import { ui as UI } from 'features/contacts'
import { $modalMode, Mode } from 'features/contacts/ui/Filters/store'
import { Param } from 'shared/search-adapters'
import { typo } from 'shared/styles'
import { Button, StackIcon } from 'shared/ui'
import { FilterTags } from 'shared/ui/Tags'

import css from './Header.module.scss'

const ORDER = [
	Param.ExecutionDistance,
	Param.ExecutionLocations,
	Param.ExecutionStatus,
	Param.ExecutionPremium,
	Param.GotAnswer,
	Param.LinkedInQualification
]

const openFilter = () => $modalMode.set(Mode.Executions)

export function Header() {
	const { campaign } = campaignHooks.useCurrent()

	return (
		<header className={css.header}>
			<h1 className={clsx(css.title, typo.subSection)}>
				{campaign?.name ?? ''}
			</h1>

			<UI.Search />

			<div className={css.filters}>
				<Button className={css.filter} onClick={openFilter}>
					<StackIcon icon='filters' width={12} />
					Filters
				</Button>
				<FilterTags order={ORDER} />
			</div>

			<Button
				className={css.add}
				onClick={UI.AddModal.open}
				variant='bordered-dark'
			>
				<StackIcon icon='plus' />
				Add more contacts
			</Button>

			{CONSTS.IS_RESIZABLE_TABLE && <UI.ColumnSettingsCampaign />}
		</header>
	)
}
